import { render, staticRenderFns } from "./SicherheitsdatenblaetterList.vue?vue&type=template&id=74d073be&scoped=true"
import script from "./SicherheitsdatenblaetterList.vue?vue&type=script&lang=js"
export * from "./SicherheitsdatenblaetterList.vue?vue&type=script&lang=js"
import style0 from "./SicherheitsdatenblaetterList.vue?vue&type=style&index=0&id=74d073be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d073be",
  null
  
)

export default component.exports